import { useIsMobile } from "../volleyball/context/mobileContext";
import NHLDesktopDashboard from "./screens/NHLDesktopDashboard";
import NHLMobileDashboard from "./screens/NHLMobileDashboard";

const NHLDashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <NHLMobileDashboard /> : <NHLDesktopDashboard />;
};

export default NHLDashboard;
